import React from 'react';
import fr from 'facet-rest';
import { pick } from 'Helpers/Affordances';
import ManagedAccountModelUpdateRequestNotesContainer
  from './ManagedAccountModelUpdateRequestNotes/ManagedAccountModelUpdateRequestNotesContainer';

const ManagedAccountModelUpdateRequestNotesPicker = ({
  managedAccountModelUpdateRequestResource,
  notesPortalRef,
}) => {
  return pick(managedAccountModelUpdateRequestResource, {
    [fr.relationships.notes.name]: <ManagedAccountModelUpdateRequestNotesContainer
      relationshipLink={managedAccountModelUpdateRequestResource.relationship(fr.relationships.notes.name).link('related')}
      notesPortalRef={notesPortalRef}
    />,
  }, null);
};

export default ManagedAccountModelUpdateRequestNotesPicker;
